import {
  readUiSettingStorageValue,
  writeUiSettingStorageValue,
} from '@affine/core/modules/ui-settings-vault';

const storageOptions = { sync: 'local-only' } as const;

function storageKey(workspaceId: string) {
  return `streamlain.aiChat.lastOpen.v1:${workspaceId}`;
}

/** The chat that was open last in this workspace, in this browser. */
export function readLastOpenChat(workspaceId: string): string | null {
  try {
    return (
      readUiSettingStorageValue(storageKey(workspaceId), storageOptions) || null
    );
  } catch {
    return null;
  }
}

/** Remembers the open chat; `null` stands for a new, still empty chat. */
export function rememberLastOpenChat(
  workspaceId: string,
  sessionId: string | null
): void {
  try {
    writeUiSettingStorageValue(
      storageKey(workspaceId),
      sessionId ?? '',
      storageOptions
    );
  } catch {
    // The browser keeps no storage: the chat opens its latest chat instead.
  }
}
